var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseMobility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.699 8.90796H58.7623C57.8904 8.90796 57.0543 9.2543 56.4378 9.8708C55.8213 10.4873 55.4749 11.3235 55.4749 12.1953V42.8685C55.4749 44.3399 57.2512 45.0689 58.2851 44.035L67.0072 35.3129H87.7122C88.5841 35.3129 89.4203 34.9665 90.0368 34.35C90.6533 33.7335 90.9996 32.8974 90.9996 32.0255V12.1953C90.9996 10.3793 89.5282 8.90796 87.699 8.90796ZM52.8106 17.365H29.9184C27.6384 17.365 25.7959 19.2075 25.7959 21.4874V25.3845H52.8106V17.365ZM48.4097 23.3564H42.4845C41.7555 23.3564 41.159 22.7599 41.159 22.0309C41.159 21.3018 41.7555 20.7053 42.4845 20.7053H48.4097C49.1388 20.7053 49.7353 21.3018 49.7353 22.0309C49.7353 22.7599 49.1388 23.3564 48.4097 23.3564Z",
    fill: "url(#paint0_linear_4_51857)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1541 45.9173C59.3455 46.7259 58.2718 47.1766 57.1319 47.1766C54.7591 47.1766 52.8238 45.2413 52.8238 42.8818V28.0356H25.7959V34.9417H41.2385C44.5126 34.9417 47.177 37.6061 47.177 40.8802V71.5534C47.177 72.7596 46.6998 73.8731 45.8249 74.6949C45.0163 75.4505 43.9692 75.8614 42.869 75.8614C41.729 75.8614 40.6553 75.4107 39.8467 74.6021L31.9067 66.6621H25.7959V77.5449H68.2399V37.9773H68.0941L60.1541 45.9173ZM25.7959 86.9695C25.7959 89.2494 27.6384 91.092 29.9184 91.092H64.1175C66.3974 91.092 68.2399 89.2494 68.2399 86.9695V80.1827H25.7959V86.9695ZM43.9957 83.6424H50.0534C50.7825 83.6424 51.379 84.2389 51.379 84.9679C51.379 85.697 50.7825 86.2935 50.0534 86.2935H43.9957C43.2666 86.2935 42.6701 85.697 42.6701 84.9679C42.6701 84.2389 43.2534 83.6424 43.9957 83.6424Z",
    fill: "url(#paint1_linear_4_51857)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7292 72.7198C42.7631 73.7537 44.5393 73.0247 44.5393 71.5533V40.8801C44.5393 40.0083 44.193 39.1721 43.5765 38.5556C42.96 37.9391 42.1238 37.5928 41.252 37.5928H12.302C11.4301 37.5928 10.594 37.9391 9.97749 38.5556C9.36099 39.1721 9.01465 40.0083 9.01465 40.8801V60.7103C9.01465 61.5822 9.36099 62.4183 9.97749 63.0348C10.594 63.6513 11.4301 63.9977 12.302 63.9977H33.0071L41.7292 72.7198ZM26.7637 42.5636C28.9509 42.5636 30.7271 44.3398 30.7271 46.527C30.7271 48.7141 28.9509 50.4904 26.7637 50.4904C24.5766 50.4904 22.8003 48.7141 22.8003 46.527C22.8003 44.3398 24.5766 42.5636 26.7637 42.5636ZM22.6148 51.6303C23.7547 52.5582 25.1863 53.1414 26.7637 53.1414C28.3411 53.1414 29.7727 52.5582 30.9127 51.6303C32.1398 52.3504 33.1572 53.3788 33.8641 54.6135C34.571 55.8482 34.9427 57.2463 34.9424 58.669H18.5851C18.5851 55.6732 20.2023 53.0487 22.6148 51.6303Z",
    fill: "url(#paint2_linear_4_51857)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_51857",
    x1: 37.0858,
    y1: 8.90796,
    x2: 65.1023,
    y2: 71.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_51857",
    x1: 33.145,
    y1: 28.0356,
    x2: 98.529,
    y2: 81.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_51857",
    x1: 15.1657,
    y1: 37.5928,
    x2: 52.0594,
    y2: 82.6079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseMobility);
export default __webpack_public_path__ + "static/media/Enterprise-Mobility.033a91aa61321677a1d9fbd2ed951967.svg";
export { ForwardRef as ReactComponent };